import { SxProps } from '@mui/material';

export const QuestionCardStyles = {
  root: {
    margin: '20px 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  container: {
    maxWidth: '1000px',
    width: '95%',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
  },
  header: {
    marginBottom: '20px',
    fontSize: '1.8rem',
    fontWeight: 600,
    textAlign: 'left',
    color: '#333',
  },
  prompt: {
    marginBottom: '20px',
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#555',
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  buttonContainer: {
    marginTop: '20px',

    marginLeft: '0px',
    marginBottom: '30px',
    display: 'flex',
  },
  modalContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '111.11vh',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    img: {
      maxWidth: '500px',
      maxHeight: '200px',
    },
  },
  modalContent: {
    width: '90%',
    maxHeight: '90vh',

    maxWidth: '700px',
    padding: '30px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    overflowY: 'auto',
  },
  modalHeader: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '1.5rem',
    color: '#333',
  },
  modalCloseButton: {
    alignSelf: 'center',
    marginTop: '10px',
  },
  explButton: {
    textTransform: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  closeIconContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '2px',
  },
  closeIconButton: {
    borderRadius: '100px',
    padding: '2px',
    margin: '0px',
    minWidth: '24px',
  },
  closeIcon: {
    color: 'rgb(137, 137, 142)',
  },
} satisfies Record<string, SxProps>;
